import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { payMobx } from '@mobxStore'
import { sortBy, values } from '@dt/fe-utils/dist/lodash'
import BankCardOnline from '../BankCardOnline/MethodItem'
import ApplePayWeb from '../ApplePayWeb/MethodItem'
import PaypalMethodItem from '../PayPalWeb/PayPalMethodItem'
import AlipayMethodItem from '../Alipay/MethodItem'
import WechatPay from '../WechatPay/MethodItem'
import './index.scss'

interface IProps {
  bills: any;
  onSelect?: any;
}

const ExternalPay = ({ bills, onSelect }: IProps) => {
  const list = useMemo(() => {
    return sortBy(values(payMobx.availableMethods), v => payMobx.channelSortMap?.[v?.channel]?.sort === undefined ? 9999 : payMobx.channelSortMap?.[v?.channel]?.sort)
  }, [payMobx.availableMethods, payMobx.channelSortMap])

  return (
    <div className='mkt-external-pay'>
      {list.length > 0 ? (
        list.map((item: any, index: number) => {
          const billItem: any = bills[item.method]
          const isSelect: any = !!billItem
          const methodItem: any = billItem || item
          if (item.method === 'bankCardOnline') {
            return <BankCardOnline key={item.method} method={methodItem} bankCards={payMobx.bankCards} selected={isSelect} onChange={(data: any) => onSelect(methodItem, data)} />
          } else if (item.method === 'applePay') {
            return <ApplePayWeb key={item.method} method={methodItem} selected={isSelect} onChange={() => onSelect(methodItem)} />
          } else if (item.method === 'paypal') {
            return <PaypalMethodItem key={item.method} method={methodItem} selected={isSelect} onChange={() => onSelect(methodItem)} />
          } else if (item.method === 'alipay') {
            return <AlipayMethodItem key={item.method} method={methodItem} selected={isSelect} onChange={() => onSelect(methodItem)} />
          } else if (item.method === 'wechatPay') {
            return <WechatPay key={item.method} method={methodItem} selected={isSelect} onChange={() => onSelect(methodItem)} />
          }
        })
      ) : (
        <div className='pay-method-none'>
          <i className='iconfont icon-kongzhuangtai2x' />
          {i18n.t('pay.noPayEnv')}
        </div>
      )}
    </div>
  )
}

export default observer(ExternalPay)
